import React from 'react';

const FilledIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='28'
      height='29'
      viewBox='0 0 28 29'
      fill='none'
    >
      <path
        d='M14 3.02502C11.7502 3.02502 9.551 3.69216 7.68039 4.94206C5.80978 6.19196 4.35182 7.96849 3.49088 10.047C2.62993 12.1255 2.40467 14.4126 2.84357 16.6192C3.28248 18.8257 4.36584 20.8525 5.95667 22.4434C7.54749 24.0342 9.57432 25.1175 11.7809 25.5565C13.9874 25.9954 16.2745 25.7701 18.353 24.9092C20.4315 24.0482 22.2081 22.5902 23.458 20.7196C24.7079 18.849 25.375 16.6498 25.375 14.4C25.3718 11.3842 24.1724 8.49274 22.0398 6.3602C19.9073 4.22767 17.0159 3.02821 14 3.02502ZM18.9941 12.3941L12.8691 18.5191C12.7878 18.6004 12.6913 18.665 12.5851 18.709C12.4789 18.753 12.365 18.7757 12.25 18.7757C12.135 18.7757 12.0212 18.753 11.9149 18.709C11.8087 18.665 11.7122 18.6004 11.6309 18.5191L9.00594 15.8941C8.84176 15.7299 8.74952 15.5072 8.74952 15.275C8.74952 15.0428 8.84176 14.8201 9.00594 14.656C9.17013 14.4918 9.39281 14.3995 9.625 14.3995C9.8572 14.3995 10.0799 14.4918 10.2441 14.656L12.25 16.663L17.7559 11.156C17.8372 11.0747 17.9338 11.0102 18.04 10.9662C18.1462 10.9222 18.26 10.8995 18.375 10.8995C18.49 10.8995 18.6038 10.9222 18.71 10.9662C18.8163 11.0102 18.9128 11.0747 18.9941 11.156C19.0754 11.2373 19.1399 11.3338 19.1838 11.44C19.2278 11.5462 19.2505 11.6601 19.2505 11.775C19.2505 11.89 19.2278 12.0038 19.1838 12.1101C19.1399 12.2163 19.0754 12.3128 18.9941 12.3941Z'
        fill='#319A2E'
      />
    </svg>
  );
};

export default FilledIcon;
